module.exports = __webpack_public_path__ + "static/HappyFeet-40-42664fd23224d45acd3dbfb9511613d3.jpg";